import { styled } from "@mui/material/styles";
import Container  from "@mui/material/Container"

export default styled(Container)`
  padding-top: 1em;
  margin-top: 7em;
`;
